import { useState, useEffect } from "react";

function useScript(src) {
  const [status, setStatus] = useState(src ? "loading" : "idle");

  useEffect(() => {
    let timerId;
    if (!src) {
      setStatus("idle");
      return;
    }

    window.addEventListener("load", () => {
      timerId = window.setTimeout(() => {
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
          script = document.createElement("script");
          script.src = src;
          script.defer = true;
          script.setAttribute("data-status", "loading");
          document.body.appendChild(script);
          const setAttributeFromEvent = (event) => {
            script && script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
          };
          script.addEventListener("load", setAttributeFromEvent);
          script.addEventListener("error", setAttributeFromEvent);
        } else {
          setStatus(script.getAttribute("data-status"));
        }

        const setStateFromEvent = (event) => {
          setStatus(event.type === "load" ? "ready" : "error");
        };

        script.addEventListener("load", setStateFromEvent);
        script.addEventListener("error", setStateFromEvent);
      }, 3000);
    });

    return () => {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
        clearInterval(timerId);
      }
    };
  }, [src]);

  return status;
}
export default useScript;
